module.exports = __webpack_public_path__ + "img/2019qinglongxia-2.4fd618a3.jpg";